import React, { useContext, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
import { CartContext } from '../Context/CartContext';

const menuUrl = "https://zomatourl.herokuapp.com/menuItem";
const placeOrderUrl = "https://zomatourl.herokuapp.com/placeOrder";

const DisplayPlaceOrder = () => {
    let total = 0;
    const { cart, setCart } = useContext(CartContext);
    const [products, setProducts] = useState([])
    const [priceFetched, setPriceFetched] = useState(false)
    const [user, setUser] = useState({
        orderId : Math.floor(Math.random()*10000),
        rest_name : [],
        cost: 0,
        name: localStorage.getItem('userdata') ? localStorage.getItem('userdata').split(',')[0] : '',
        email: localStorage.getItem('userdata') ? localStorage.getItem('userdata').split(',')[1] : '',
        phone: localStorage.getItem('userdata') ? localStorage.getItem('userdata').split(',')[2] : '',
        address: 'Mumbai',
        menuItems: []
    })
   

    let size = cart.totalItems ? cart.totalItems : 0;
    // console.log(size);

    useEffect(() => {
        if (size > 0) {
            getCartItem();
            getSum()
        }
        else {
            return (
                <h1>First Add Item</h1>
            )
        }
    }, [])


    let name, value;
    const changeHandle = (e) => {
        name = e.target.name;
        value = e.target.value;
        setUser({ ...user, [name]: value })
    }

    const getCartItem = () => {
        let menulist = Object.keys(cart.items)
        // console.log(menulist);
        let result = menulist.map(i => Number(i))
        user.menuItems = result;
        // console.log(result);
        if (priceFetched) {
            return
        } else {
            fetch(menuUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(result)
            })
                .then(res => res.json())
                .then(data => {
                    setProducts(data)
                    data.filter(d => {
                        // console.log(d);
                        user.rest_name.push(`${d.menu_name}, `)
                    })
                    setPriceFetched(true)
                })
                .catch(err => {
                    console.log(err);
                })
        }
    }

    const increment = (menuId) => {
        const existingQty = cart.items[menuId]
        const _cart = { ...cart }
        _cart.items[menuId] += 1;
        _cart.totalItems += 1;
        setCart(_cart);
    }

    const decrement = (menuId) => {
        const _cart = { ...cart }
        if (_cart.items[menuId] === 1) {
            return _cart;
        }
        _cart.items[menuId] -= 1;
        _cart.totalItems -= 1;
        setCart(_cart)
    }

    const getQty = (menuId) => {
        return cart.items[menuId]
    }
    const getSum = (menuId, price) => {
        // console.log(menuId, price);
        const sum = price * getQty(menuId)
        // console.log(sum);
        total = total+sum;
        user.cost = total
        return sum;
    }
    
    const handleDelete = (menuId) => {
        const existingQty = cart.items[menuId]
        const _cart = { ...cart };
        delete _cart.items[menuId]
        _cart.totalItems = _cart.totalItems - existingQty;
        setCart(_cart);
        const updatedProductList = products.filter((product) =>
            product.menu_id !== menuId)
        setProducts(updatedProductList)
    }
    
    const handleOrderNow = () => {
        fetch(placeOrderUrl, {
            method : "POST",
            headers : {
                'Accept' : 'application/json',
                'Content-Type' : 'application/json'
            },
            body : JSON.stringify(user)
        })
        .then(res => res.json())
        .then(data => {
            // console.log(data);
            // let newcart = localStorage.removeItem('cart')
            // setCart(0)
            
        })
        .catch(err => {
            console.log(err);
        })
    }

    let userToken = localStorage.getItem('authToken')

    return (
        <React.Fragment>
            {
                !userToken ? (
                    <h1 style={{ marginTop: "120px", textAlign: "center" }}>Login First to Place Order</h1>
                ) : (
                    <div className="container border p-4 mt-5">
                        <form action="https://paytmlive.herokuapp.com/paynow" method='POST'>
                            <div className="bg-success text-white p-3 mb-4" style={{ borderRadius: "8px" }}>
                                <h3>Your Selected Order List </h3>
                            </div>
                            <input type="hidden" name="id" value={user.orderId} />
                            <input type="hidden" name="rest_name" value={user.rest_name} />
                            <input type="hidden" name="cost" value={user.cost} />
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input type="text" name='name' className="form-control" id="name" value={user.name} onChange={changeHandle} />
                            </div>

                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email address</label>
                                <input type="email" name='email' className="form-control" id="email" value={user.email} onChange={changeHandle} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="phone" className="form-label">Phone</label>
                                <input type="text" name='phone' className="form-control" id="phone" value={user.phone} onChange={changeHandle} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="address" className="form-label">Address</label>
                                <input type="text" name='address' className="form-control" id="address" value={user.address} onChange={changeHandle} />
                            </div>
                            <div className="m-3">
                                <Button className='bg-success text-bold rounded-3' type='submit' onClick={handleOrderNow}>Place Order</Button>
                            </div>
                        </form>
                        {
                            size < 1 ? (
                                <div className="container">
                                    <img src="https://i.pinimg.com/736x/2e/ac/fa/2eacfa305d7715bdcd86bb4956209038--android.jpg" alt="empty" style={{ objectFit: "contain" }} />
                                </div>
                            ) : (

                                <div className='container'>
                                    <h1>Cart Items</h1>
                                    <div className="container">
                                        <div className="lists d-flex flex-column">
                                            {
                                                products.map((product, index) => {
                                                    return (
                                                        <div className="product-details d-flex mb-3" key={index}>
                                                            <div className="img">
                                                                <img src={product.menu_image} alt={product.menu_name} />
                                                            </div>
                                                            <div className="desc">
                                                                <h5>{product.menu_name}</h5>
                                                            </div>
                                                            <div className="button  m-auto text-center">
                                                                <button onClick={() => { decrement(product.menu_id) }}>-</button>
                                                                <span>{getQty(product.menu_id)}</span>
                                                                <button onClick={() => { increment(product.menu_id) }}>+</button>
                                                            </div>
                                                            <div className="price m-auto text-center">
                                                                <h4>₹{getSum(product.menu_id, product.menu_price)}</h4>
                                                            </div>
                                                            <div className="delete text-center">
                                                                <button onClick={() => { handleDelete(product.menu_id) }}>delete</button>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>

                                </div>
                            )
                        }
                        <hr />

                        <div className="grandtotal">
                            <h3>Grand Total : ₹{total} </h3>
                        </div>
                    </div>
                )
            }
        </React.Fragment>
    )
}

export default DisplayPlaceOrder